import { BaseClass } from './base'

export class GoodsClass extends BaseClass {
  modelRef = {
    title: '',
    subTitle: '',
    isSelling: true,
    pic: '',
    banner: '',
    content: '',
    stockPrice: 0,
    sellingPrice: 0,
    promotionPrice: 0,
    quantity: 0,
    unit: '',
    specification: '',
    brand: '',
    remark: '',
    goodsCategoryId: 0
  }

  rulesRef = {
    title: [
      {
        required: true,
        message: '请输入名称'
      }
    ],
    goodsCategoryId: [
      {
        required: true,
        message: '请选择分类'
      }
    ]
  }

  gets (params) {
    return this.get(this.goods, params)
  }

  detail (id) {
    return this.get(this.goods + `/${id}`)
  }

  create (data) {
    return this.post(this.goods, data)
  }

  update (data) {
    return this.put(this.goods, data)
  }

  del (id) {
    return this.delete(this.goods + `/${id}`)
  }

  selling (id, status) {
    return this.get(`/api/Goods/SetActiveStatus/${id}/${status}`)
  }
}

/**
 * 商品分类
 */
export class GoodsCategoryClass extends BaseClass {
  modelRef = {
    parentId: 0,
    title: '',
    pic: '',
    sort: 0
  }

  rulesRef = {
    title: [
      {
        required: true,
        message: '请输入标题'
      }
    ]
  }

  gets (params) {
    return this.get(this.goodsCate, params)
  }

  detail (id) {
    return this.get(this.goodsCate + `/${id}`)
  }

  create (data) {
    return this.post(this.goodsCate, data)
  }

  update (data) {
    return this.put(this.goodsCate, data)
  }

  del (id) {
    return this.delete(this.goodsCate + `/${id}`)
  }

  sort (id, sort) {
    return this.get(this.goodsCate + `/Sort/${id}/${sort}`)
  }
}

export class OrderClass extends BaseClass {
  modelRef = {
    customerName: '',
    customerMobile: '',
    address: '',
    goodsId: '',
    userId: '',
    userPics: ''
  }

  rulesRef = {
    customerName: [
      {
        required: true,
        message: '请输入用户姓名'
      }
    ],
    customerMobile: [
      {
        required: true,
        message: '请输入用户手机号'
      }
    ],
    address: [
      {
        required: true,
        message: '请输入用户详细地址'
      }
    ]
  }

  gets (params) {
    return this.get(this.order, params)
  }

  update (data) {
    return this.put(this.order, data)
  }

  create (data) {
    return this.post(this.order, data)
  }

  detail (id) {
    return this.get(this.order + `/${id}`)
  }

  exportAll (params) {
    return this.export('/api/Order/Export', 'GET', params)
  }

  exportMerge (params) {
    return this.export('/api/Order/MergeMoneyExport', 'GET', params)
  }

  setWorker (id, workerId) {
    return this.post(this.order + '/SetWorker', { id, workerId })
  }

  status (id, status) {
    return this.post('/api/Order/SetState', { id, status })
  }

  getLastOrder () {
    return this.get('/api/Order/GetLastOrder')
  }
}
